<button
  mat-icon-button
  class="notification-menu__button btn btn--sm btn--icon btn--no-bg"
  [matMenuTriggerFor]="notificationMenu"
  (menuOpened)="onMenuOpened()"
>
  <fa-icon [icon]="['fass', 'bell']" class="notification-menu__notification-icon"></fa-icon>
  @if (badgeCount > 0) {
  <span class="notification-menu__badge">{{ badgeCount }}</span>
  }
</button>

<mat-menu #notificationMenu="matMenu" class="notification-menu__panel">
  @if (!hasNotifications) {
<div class="notification-menu__empty">
    {{ 'NOTIFICATIONS.NO_ITEMS' | translate }}
  </div>
}

  @if (hasNotifications) {

    @for (
        notification of displayedNotifications; track trackByNotification($index, 
        notification)) {
<button
      mat-menu-item
      class="notification-menu__item"
     
      (click)="onNotificationClick(notification)"
    >
      <div class="notification-menu__item-content">
        <div class="notification-menu__item-image-wrapper">
          <img
            class="notification-menu__item-image"
            [src]="
              notification.image
                ? notification.image + '?format=thumbnail'
                : 'images/avatar-placeholder.png'
            "
            alt="notification image"
          />
          <span
            class="notification-menu__item-icon"
            [style.backgroundColor]="notification.config?.color"
          >
            <fa-icon [icon]="notification.config?.icon | faIconName : 'fass'"></fa-icon>
          </span>
        </div>
        <div class="notification-menu__item-text">
          <span class="notification-menu__item-title">
            {{ notification.title }}
          </span>
          <span
            class="notification-menu__item-description"
            [innerHTML]="notification.description"
          >
          </span>
        </div>
        <div class="notification-menu__item-status">
          @if (notification.read === false) {
          <span class="notification-menu__unread-dot"></span>
          }
        </div>
      </div>
    </button>
}
  
}

  <div class="notification-menu__show-all">
    <button mat-menu-item class="btn btn--sm btn--no-bg" (click)="onShowAll()">
      {{ 'NOTIFICATIONS.SHOW_ALL' | translate }}
    </button>
  </div>
</mat-menu>
